import {
  string as yupString,
  number as yupNumber,
  date as yupDate,
} from 'yup';

import InputFormik from '../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../shared/forms/select/sdkSelectFormik.component';
import TextAreaFormik from '../../shared/forms/textarea/textareaFormik.component';
import DatepickerFormik from '../../shared/forms/datepicker/datepickerFormik.component';
import { required } from '../../shared/forms/validators';

import { CommunicationStatuses, CommunicationTypesOptions } from '../../dashboard/constants';
import CommunicationPreview from './communicationPreview.component';

const schema = [
  {
    name: 'title',
    component: InputFormik,
    meta: { label: 'Title' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'nameOverride',
    component: InputFormik,
    meta: { label: 'Name Override' },
    options: { yupType: yupString() },
  },
  {
    name: 'clientId',
    component: SelectFormik,
    meta: { label: 'Client', optionsKey: 'clientsToChooseFrom' },
    options: { yupType: yupNumber(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'type',
    component: SelectFormik,
    meta: { label: 'Type', options: CommunicationTypesOptions },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'status',
    component: SelectFormik,
    meta: { label: 'Status', options: CommunicationStatuses },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'publishOn',
    component: DatepickerFormik,
    meta: { label: 'Publish On', yupType: yupDate() },
    additionalProps: {
      mode: 'showTime',
    },
  },
  {
    name: 'expiresOn',
    component: DatepickerFormik,
    meta: { label: 'Expires On', yupType: yupDate() },
    additionalProps: {
      mode: 'showTime',
    },
  },
  {
    name: 'bodyText',
    component: TextAreaFormik,
    meta: { label: 'Body Text' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true, rows: 7, resize: 'vertical' },
  },
  {
    name: 'preview',
    meta: { valueGetter: ({ formik, formContext }) => ({
      name: formik.values.nameOverride || formContext.userName,
      title: formik.values.title,
      bodyText: formik.values.bodyText,
      type: formik.values.type,
      publishedOn: Date.now(),
      isEditMode: formContext.openForEdit,
    }) },
    component: CommunicationPreview,
    options: { readOnly: true },
  },
];

export default schema;
